module.exports = __webpack_public_path__ + "img/processing.2ee1e012.gif";